import { render, staticRenderFns } from "./MenuItemAmount.vue?vue&type=template&id=f6ea0b48"
import script from "./MenuItemAmount.vue?vue&type=script&lang=js"
export * from "./MenuItemAmount.vue?vue&type=script&lang=js"
import style0 from "./MenuItemAmount.vue?vue&type=style&index=0&id=f6ea0b48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports